import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'price',pure:false })
export class PricePipe implements PipeTransform {
  
  constructor(private translateService:TranslateService,private currencyPipe:CurrencyPipe){
  }
  transform(price, status, currency, priceMode?) {
    let display:string = status=='estimated'?'±':'';
    display += this.currencyPipe.transform(price,currency.toUpperCase());
    display += priceMode === 'VATExcluded' ? this.translateService.instant('tax.VATExcludedShort'): '';
    return display;
  }
}